import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
const DEFAULT_INFRASTRUCTURE = 'azure';
const SgwtWidgetContext = createContext({
    infrastructure: DEFAULT_INFRASTRUCTURE,
});
const SgwtWidgetContextProvider = (props) => {
    const infrastructure = useMemo(() => props.infrastructure ?? DEFAULT_INFRASTRUCTURE, [props.infrastructure]);
    return _jsx(SgwtWidgetContext.Provider, { value: { infrastructure }, children: props.children });
};
export { SgwtWidgetContextProvider, SgwtWidgetContext };
//# sourceMappingURL=SgwtWidgetContext.js.map